export default {

    /** URL de Autenticacion */
    APP_BYM_BASE: process.env.VUE_APP_BYM_API,
    APP_ECOMMERCE_BASE: process.env.VUE_APP_ECOMMERCE_API,
    APP_ECOMMERCE_CLIENT_KEY: process.env.VUE_APP_ECOMMERCE_CLIENT_KEY,
    APP_ECOMMERCE_CLIENT_SECRET_KEY: process.env.VUE_APP_ECOMMERCE_CLIENT_SECRET_KEY
}
